import { render, staticRenderFns } from "./AvatarMenu.vue?vue&type=template&id=45781eda&scoped=true&"
import script from "./AvatarMenu.vue?vue&type=script&lang=js&"
export * from "./AvatarMenu.vue?vue&type=script&lang=js&"
import style0 from "./AvatarMenu.vue?vue&type=style&index=0&id=45781eda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45781eda",
  null
  
)

export default component.exports